import { useEffect, useState } from "react";

export default function ScrollProgress() {
    const [p, setP] = useState(0);
    useEffect(() => {
        const on = () => {
            const h = document.documentElement;
            const total = h.scrollHeight - h.clientHeight;
            setP(total > 0 ? (h.scrollTop / total) * 100 : 0);
        };
        on();
        window.addEventListener("scroll", on, { passive: true });
        return () => window.removeEventListener("scroll", on);
    }, []);
    return (
        <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent pointer-events-none" data-testid="scroll-progress">
            <div
                className="h-full bg-secondary transition-[width] duration-100 ease-out"
                style={{ width: `${p}%` }}
            />
        </div>
    );
}
